export var PLACEHOLDER = 'placeholder';